import type { BuyerParticipationRequestDetailDto } from "../../../../../autogen/bff-api";
import { QualificationDecisionCard } from "./QualificationDecisionCard";

interface Props {
  eventId: string;
  detail: BuyerParticipationRequestDetailDto;
  onShowEspd: () => void;
}

// Dedicated tab for the qualification decision. The card recomputes server-truth
// progress from `detail` when no optimistic count is supplied, so this tab does
// not pass `optimisticReviewed` — the live review editor lives on the requirements tab.
export const RequestDecisionTab = ({ eventId, detail, onShowEspd }: Props) => (
  <QualificationDecisionCard eventId={eventId} detail={detail} onShowEspd={onShowEspd} />
);
